module.exports = __webpack_public_path__ + "img/tangFive.91770362.png";